import { retryWhen, delay, take } from 'rxjs/operators';
import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Params,
  Router
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { PasswordRestriction } from '../models/auth.class';
import { Activity } from '../models/finance.class';
import { AuthService } from '../services/auth.service';
import { AuthGuard } from '../services/auth-guard.service';
import { CryptographyService } from '../services/cryptography.service';
import { DialogService } from '../services/dialog.service';
import { FinanceService } from '../services/finance.service';
import { FeatureFlagService } from '../services/feature-flag.service';
import { MemberService } from '../services/member.service';
import { NotificationService } from '../services/notification.service';
import { ReferralService } from '../services/referral.service';
import { ScriptInjectorService } from '../services/script-injector.service';
import { UserService } from '../services/user.service';
import { SsoService } from '../services/sso.service';
import { ReviewAppService } from '../services/review-app.service';
import { MenuService } from '../services/menu.service';
import { BaseParameterService } from '../services/base-parameter.service';
import { HeaderService } from '../services/header.service';
import { ENVIRONMENT } from '../../environments/environment';
import { EventService } from '../services/event.service';
import { LanguageService } from '../services/language.service';
import { UtilityService } from '../services/utility.service';
import CONFIGURATION, { isTestingEnvironment, hasLandingPageFor, landingPagePathFor, getLandingPageProperties } from '../../configurations/configuration';
import { TwoFaConfig } from '../components/two-fa/two-fa-common/two-fa-interface';
import { SessionStorageService } from 'ngx-webstorage';
import { forkJoin as observableForkJoin, Observable } from 'rxjs';
import * as Sentry from '@sentry/angular';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

@Component({
  selector: 'header-section',
  templateUrl: './header.html',
  styleUrls: ['../../assets/scss/pantry/index.scss'],
})
export class HeaderComponent implements OnInit {
  baseUrls: any;
  formModel: any;
  headerModel: any;
  memberModel: any;
  memberTypeCodes: any;
  modal: any;
  navigationAccess: any;
  countryFlagCode: string;
  showMenuContainer: boolean;
  showPublicNavigationBar: boolean;
  showReferBox: boolean;
  showServiceBox: boolean;
  _countryCode: string;
  _environment: string;
  countryCode: string;
  countries: Array<Object>;
  environments: Array<Object>;
  isTestingEnvironment: Boolean;
  showBalanceCash: Boolean;
  showHelp: Boolean;
  showFeedback: Boolean;
  showPrivacyNotice: Boolean;
  headerLogoClassNamePrefix: any;
  CONFIGURATION: any;
  hasLandingPageFor: any;
  landingPagePathFor: any;
  landingPageProperties: any;
  languageLabel: string;
  twoFaConfig: TwoFaConfig;
  showHomepageCampaignBanner: boolean;
  partialDownTimeBanner: any;
  featureFlagObservable: Observable<any>;
  redirectUrl: string;
  showWarning: boolean;
  showFacilityLoan: boolean;
  faqLink: string;
  reverificationReasonProperties: any;
  reverificationReasonList: any;
  loginHeaderTranslation: any;
  navigation = {
    logoPath: CONFIGURATION.header_vertical_logo_path,
    mobileHamburgerMenuOpen: false,
    activeMobileSubMenu: '',
    desktopSubMenuOpen: {
      borrow: false,
      about: false,
      login: false,
    }
  };
  showReverificationBanner = CONFIGURATION.reverification.show;
  navigationConfiguration = CONFIGURATION.navigation;
  timeLeftToLogout: number;

  @ViewChild('borrowDesktopMenu', { static: false }) borrowDesktopMenu: ElementRef;
  @ViewChild('aboutDesktopMenu', { static: false }) aboutDesktopMenu: ElementRef;
  @ViewChild('loginDesktopMenu', { static: false }) loginDesktopMenu: ElementRef;
  showCreateNewLoanButton = CONFIGURATION.showCreateNewLoanButton;
  showcompleteAccountActivationButton = CONFIGURATION.header.completeAccountActivation.show;

  public constructor(
    private _activatedRoute: ActivatedRoute,
    private _authService: AuthService,
    private _authGuardService: AuthGuard,
    private baseParameterService: BaseParameterService,
    private _cryptographyService: CryptographyService,
    private _dialogService: DialogService,
    private _financeService: FinanceService,
    private _localStorageService: LocalStorageService,
    private _memberService: MemberService,
    private _notificationService: NotificationService,
    private featureFlagService: FeatureFlagService,
    private _referralService: ReferralService,
    private _renderer: Renderer2,
    private _router: Router,
    private _scriptInjectorService: ScriptInjectorService,
    private _translateService: TranslateService,
    private _userService: UserService,
    private _ssoService: SsoService,
    private _reviewAppService: ReviewAppService,
    private _menuService: MenuService,
    private headerService: HeaderService,
    private _languageService: LanguageService,
    private eventService: EventService,
    private _sessionStorageService: SessionStorageService,
    private idle: Idle,
    private keepalive: Keepalive,
    private renderer: Renderer2,
    private utilityService: UtilityService
  ) {
    this.CONFIGURATION = CONFIGURATION;
    this.hasLandingPageFor = hasLandingPageFor;
    this.landingPagePathFor = landingPagePathFor;
    this.landingPageProperties = getLandingPageProperties;
    this.baseUrls = ENVIRONMENT.baseUrls;
    this.countryFlagCode = CONFIGURATION.country_code.toLowerCase();
    this.countryCode = CONFIGURATION.country_code;
    this.showHelp = CONFIGURATION.help.show.loggedInPage;
    this.showFeedback = CONFIGURATION.menu.feedback;
    this.showPrivacyNotice = CONFIGURATION.showPrivacyNotice;
    this.isTestingEnvironment = isTestingEnvironment();
    this.formModel = {
      activation: {
        error: ''
      },
      referral: {
        borrowerLink: window.location.origin + '/sign-up-borrower?referral=',
        code: '',
        copiedMessage: '',
        investorLink: window.location.origin + '/sign-up-investor?referral=',
        sharedTitle: ''
      },
      signUpBorrower: {
        accepted: true,
        catch: false,
        error: '',
        howDidYouFindUsOtherValid: true,
        memberTypeCode: CONFIGURATION.member_type_code.borrower,
        params: new Array<any>(),
        passwordRestrictions: new Array<PasswordRestriction>(),
        passwordValid: true,
        referralRemark: null,
        retypedPasswordMatches: true,
        showHowDidYouFindUsOther: false,
        success: '',
        validation: false,
        mobilePhoneValidation: false
      },
      signUpInvestor: {
        accepted: true,
        catch: false,
        error: '',
        howDidYouFindUsOtherValid: true,
        memberTypeCode: CONFIGURATION.member_type_code.investor,
        params: new Array<any>(),
        passwordRestrictions: new Array<PasswordRestriction>(),
        passwordValid: true,
        referralRemark: null,
        retypedPasswordMatches: true,
        showHowDidYouFindUsOther: false,
        subscribeNewsletter: false,
        success: '',
        validation: false,
        mobilePhoneValidation: false
      }
    };
    this.memberTypeCodes = CONFIGURATION.member_type_code;
    this.navigationAccess = null;
    this.languageLabel = this._languageService.getDefaultLanguageLabel(this._languageService.getDefaultLanguage());
    this.initialize();
    this.showWarning = false;
    this.showHomepageCampaignBanner = false;
    this.partialDownTimeBanner = {
      enabled: false,
      message: ''
    }
    // Facility Loan
    this.showFacilityLoan = CONFIGURATION.showFacilityLoan;
    this.reverificationReasonProperties = this.baseParameterService.getReverificationReasonProperties();
    this.showReverificationBanner = CONFIGURATION.reverification.show;
    this.loginHeaderTranslation = {
      login: '',
      welcome: ''
    }

    // when clicking outside the element should close the sub menu
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.showPublicNavigationBar) {
        return;
      }

      if (this.countryCode === 'MY' &&
        !this.borrowDesktopMenu.nativeElement.contains(e.target) &&
        !this.loginDesktopMenu.nativeElement.contains(e.target)) {
        this.closeAllDesktopSubMenus();
      }
      if (this.countryCode === 'SG' &&
        !this.aboutDesktopMenu.nativeElement.contains(e.target) &&
        !this.loginDesktopMenu.nativeElement.contains(e.target)) {
        this.closeAllDesktopSubMenus();
      }
    });
  }

  ngOnInit() {
    this.getFaqLink(this._languageService.getDefaultLanguage());
    if (this._localStorageService.retrieve('showappbanner') === null) {
      this._localStorageService.store('showappBanner', true);
    };

    // this.getFeatureFlag();

    this._activatedRoute
      .queryParams
      .subscribe((params: Params) => {
        if (params['redirect']) {
          this.redirectUrl = params['redirect'];
        }
      });

    // This is needed as the the local storage it not updated with the latest language change
    this._languageService.languageChangeEventEmitter.subscribe(response => {
      this.languageLabel = this._languageService.getDefaultLanguageLabel(this._languageService.getDefaultLanguage());
      this.getFaqLink(this._languageService.getDefaultLanguage());
    });

    this._authService
      .logInEventEmitter
      .subscribe(
        isLoggedIn => {
          this.headerModel.activities = new Array<Activity>();
          this.headerModel.isLoggedIn = isLoggedIn;
          this.showBalanceCash = this._authService.getMemberTypeCode() === this.memberTypeCodes.investor && CONFIGURATION.wallet.show;
          if (!this.headerModel.isLoggedIn) {
            this.clearLogInSession();
          } else {
            this.getLogInDetails(false);
            if (this.showBalanceCash) {
              this._financeService.triggerBalanceRetrieval();
            }
          }
        }
      );


    this._authService
      .navigationEventEmitter
      .subscribe(
        showPublicNavigationBar => {
          this.showPublicNavigationBar = showPublicNavigationBar;
          setTimeout(() => {
            if (!showPublicNavigationBar) {
              this._scriptInjectorService.append(this._renderer,
                'dashboardnav_hype_generated_script',
                './assets/js/dashboard-nav.hyperesources/dashboardnav_hype_generated_script.js');
            } else {
              this._scriptInjectorService.remove(this._renderer, 'dashboardnav_hype_generated_script');
            }
          }, 0);
        }
      );

    this._authGuardService
      .navigationEventEmitter
      .subscribe(
        response => {
          // -- Logic to display the navigation
          this.navigationAccess = {
            borrower: this._authGuardService.getBorrowerNavigation(),
            investor: this._authGuardService.getInvestorNavigation()
          };
        }
      );

    this._dialogService
      .activationDialogEventEmitter
      .subscribe(
        response => {
          const userName = response['username'];
          const countryId = response['country_id'];
          const token = sessionStorage.getItem('activationToken');
          if (userName && countryId && token) {
            this._memberService.activate(countryId, userName, token).subscribe(
              memberActivatedResponse => {
                if (memberActivatedResponse.data.memberTypeCode === CONFIGURATION.member_type_code.investor) {
                  this.eventService.sendInvSignupEvent('INV-email-verified');
                } else if (memberActivatedResponse.data.memberTypeCode === CONFIGURATION.member_type_code.borrower &&
                  this.CONFIGURATION.country_code !== 'ID') {
                  this.eventService.sendBrwSignupEvent('BRW-email-verified');
                }
                this.showModal('ACTIVATION-SUCCESS');
                sessionStorage.removeItem('activationToken')
              },
              error => {
                this.formModel.activation.error = error.message;
                this.showModal('ACTIVATION-FAILED');
              }
            );
          } else {
            this.showModal('ACTIVATION-FAILED');
          }
        }
      );

    this._dialogService
      .logInDialogEventEmitter
      .subscribe(
        response => {
          this.showModal('LOG-IN');
        }
      );

    this._dialogService
      .twoFalogInDialogEventEmitter
      .subscribe(
        twoFaData => {
          this.showModal('TWO-FA-LOG-IN', twoFaData);
        }
      );

    if (this.showReverificationBanner) {
      this._memberService.getReverificationReasons().subscribe((value) => {
        this.showWarning = value.length > 0;
        this.reverificationReasonList = value;
      });
    }

    this._dialogService
      .closeAllDialogEventEmitter
      .subscribe(
        response => {
          this.closeAllModals();
        }
      );

    this._financeService
      .balanceEventEmitter
      .subscribe(
        response => {
          this._financeService.getBalance()
            .subscribe(
              balance => {
                this.memberModel.balance = balance.value;
                this._financeService.setMemberBalance(this.memberModel.balance);
              },
              error => {
                console.error('ERROR', error);
              }
            );
        });

    this._menuService
      .menuEventEmitter
      .subscribe(
        response => {
          this.toggleMenu();
        }
      );

    this._router
      .events
      .subscribe((e) => {
        if (e instanceof NavigationEnd) {
          if (this.getMemberTypeCode() !== '') {
            this._authService.setLogIn(true);
          } else {
            this.clearLogInSession(e.url.indexOf('admin-investor') >= 0 || e.url.indexOf('admin-borrower') >= 0);
          }
        }
      });

    this._translateService
      .get('referral')
      .subscribe(
        labels => {
          this.formModel.referral.copiedMessage = labels['copied'];
          this.formModel.referral.sharedTitle = labels['shared-title'];
        }
      );

    this._authService
      .twoFaLoginEventEmitter
      .subscribe(
        twoFaLogIn => {
          this.onTwoFaLogin();
        }
      );

    this._translateService
      .get('navigation')
      .subscribe(
        navigation => {
          this.loginHeaderTranslation.welcome = navigation['welcome'];
          this.loginHeaderTranslation.login = navigation['log-in'];
        });
  }

  monitorInactivity() {
    if (this.idle.isRunning()) return;

    const IDLE = this._authService.getRelativeExpiryTime(), // User is considered idle if they're inactive for IDLE seconds
      TIMEOUT = 60, // They have time till the 21st min to overrule
      INTERVAL = IDLE + 1;

    this.idle.setIdle(IDLE);
    this.idle.setTimeout(TIMEOUT);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.onIdleStart.subscribe(() => this.showModal('INACTIVITY-PROMPT'));
    this.idle.onIdleEnd.subscribe(() => this.closeAllModals());
    this.idle.onTimeout.subscribe(() => this.logOut());
    this.idle.onTimeoutWarning.subscribe((t) => this.timeLeftToLogout = t);

    /**
     * If the user becomes inactive right after logging in, since the idle and ping countdowns start at the same time, there'll be a ping at the same time the user is considered idle, if both the durations are same
     * To overcome, make the idle countdown end 1 second before the ping countdown by increasing the duration of ping countdown by 1
     */
    this.keepalive.interval(INTERVAL);
    this.keepalive.onPing.subscribe(() => {
      const accessTokenLastRefreshedAt = this._authService.getAccessTokenLastRefreshedAt();

      if ((Date.now() - accessTokenLastRefreshedAt) / 1000 >= INTERVAL) {
        this._ssoService.refreshJwtToken();
      }
    });

    this.idle.watch();
  }

  getFaqLink(currentLanguage: string) {
    this.faqLink = CONFIGURATION.help.general[currentLanguage];
  }

  clearLogInSession(navigateToHome: boolean = true): void {
    this.initialize();
    this.showMenuContainer = false;
    this.idle.stop();

    try {
      delete window['HYPE']['documents']['dashboard-nav'];
    } catch (e) {
    }

    if (navigateToHome) {
      window.location.href = '/';
    }
  }

  onClickCloseAllModals(): void {
    this._router.navigateByUrl('');
    this.closeAllModals();
  }

  closeAllModals(excludedModal?: string): void {
    this.modal.open = false;
    // Borrowed from modal.component close() method
    this._renderer.removeClass(document.body, 'modal-open-fix-for-ios');
    Object.keys(this.modal).forEach(key => {
      this.modal[key] = excludedModal === key;
    });
  }

  closeServiceBox() {
    this.showServiceBox = false;
  }

  getFullname(): string {
    if (this.headerModel.isLoggedIn) {
      if (this.loginHeaderTranslation.welcome) {
        return this.loginHeaderTranslation.welcome + ', ' + this.memberModel.fullName;
      } else {
        return 'Welcome, ' + this.memberModel.fullName;
      }
    } else {
      return this.loginHeaderTranslation.login ? this.loginHeaderTranslation.login : 'Log In';
    }
  }

  getLogInDetails(navigateToDashboard: boolean, loginResponse: any = null): void {
    this._memberService
      .getLoginDetail()
      .subscribe(
        member => {
          if (loginResponse) {
            this._authService.logIn(
              member.memberTypeName,
              String(member.id),
              member.userName,
              member.uuid
            );
          }

          Sentry.setContext('character', {
            email: member.userName
          });

          window['FS'].identify(member.id, {
            email: member.userName
          });
          if (
            member &&
            member.countryId === CONFIGURATION.country_code &&
            member.memberTypeCode === this._authService.getMemberTypeCode()
          ) {
            // MONITOR INACTIVITY
            this.monitorInactivity();

            // ACCESS LEVEL VALIDATION
            let accessLevel = CONFIGURATION.access_level_code.administrator;
            let subaccount = null;
            if ((member.userName !== this._authService.getSubaccountUserName())) {
              subaccount = member.subaccounts.find(element => {
                return element.userName === this._authService.getSubaccountUserName();
              });
              if (subaccount) {
                accessLevel = subaccount.accessLevel;
              }
            }

            // ACTIVATION STEP VALIDATION
            let activationStepCode = '';
            if (
              member.activationStepCode !== null &&
              member.activationStepCode === CONFIGURATION.activation_step_code.fill_information
            ) {
              this._financeService
                .getDeposit()
                .subscribe(
                  response => {
                    if (CONFIGURATION.wallet.show) {
                      activationStepCode = response.value.total > 0 ?
                        CONFIGURATION.activation_step_code.first_deposit :
                        (
                          member.activationStepCode !== null ?
                            member.activationStepCode :
                            CONFIGURATION.activation_step_code.null
                        );
                    } else {
                      activationStepCode = member.activationStepCode;
                    }
                    this.formModel.referral.code = member.referralCode;
                    this.setHeaderFullName(member);
                    this.memberModel.userName = member.userName;
                    this._authService
                      .setLogInDetails(
                        accessLevel,
                        activationStepCode,
                        member.memberStatusCode,
                        member.referralCode,
                        member.referralId ? member.referralId : 0,
                        subaccount ? subaccount.id : 0,
                        subaccount ? subaccount.userName : '',
                        member.isInstitutional,
                        member.memberEntityTypeId,
                        member.needsRDNOpening,
                        member.activatedAt,
                        member.memberChangeRequestEntity,
                        member.memberEntityCode,
                        member.memberActivationStatusCode);
                    this._authService.setFullName(member.fullName);
                    if (navigateToDashboard) {
                      this.navigateToDashboard();
                    }
                  },
                  error => {
                    activationStepCode = member.activationStepCode !== null ?
                      member.activationStepCode :
                      CONFIGURATION.activation_step_code.null;
                    this.formModel.referral.code = member.referralCode;
                    this.setHeaderFullName(member);
                    this.memberModel.userName = member.userName;
                    this._authService
                      .setLogInDetails(
                        accessLevel,
                        activationStepCode,
                        member.memberStatusCode,
                        member.referralCode,
                        member.referralId ? member.referralId : 0,
                        subaccount ? subaccount.id : 0,
                        subaccount ? subaccount.userName : '',
                        member.isInstitutional,
                        member.memberEntityTypeId,
                        member.needsRDNOpening,
                        member.activatedAt,
                        member.memberChangeRequestEntity,
                        member.memberEntityCode,
                        member.memberActivationStatusCode,
                      );
                    this._authService.setFullName(member.fullName);
                    if (navigateToDashboard) {
                      this.navigateToDashboard();
                    }
                  }
                );
            } else {
              activationStepCode = member.activationStepCode !== null ?
                member.activationStepCode :
                CONFIGURATION.activation_step_code.null;
              this.formModel.referral.code = member.referralCode;
              this.setHeaderFullName(member);
              this.memberModel.userName = member.userName;
              this._authService
                .setLogInDetails(
                  accessLevel,
                  activationStepCode,
                  member.memberStatusCode,
                  member.referralCode,
                  member.referralId ? member.referralId : 0,
                  subaccount ? subaccount.id : 0,
                  subaccount ? subaccount.userName : '',
                  member.isInstitutional,
                  member.memberEntityTypeId,
                  member.needsRDNOpening,
                  member.activatedAt,
                  member.memberChangeRequestEntity,
                  member.memberEntityCode,
                  member.memberActivationStatusCode,
                );
              if (navigateToDashboard) {
                if (this._localStorageService.retrieve('fromSBN')) {
                  this._router.navigate(['/admin-investor/sbn-retail']);
                  this._localStorageService.clear('fromSBN');
                } else {
                  this.navigateToDashboard();
                }
              }
            }
            this._authService.setFullName(this.memberModel.fullName);
          } else {
            this.logOut();
          }
        },
        error => {
          const expiryTime = this._authService.getExpiryTime();
          const sessionAbleToRefresh = expiryTime !== '' && this._authService.getRememberMe();
          const numberOfRefresh = this._sessionStorageService.retrieve('numberOfRefresh') ?
            this._sessionStorageService.retrieve('numberOfRefresh') : 0;
          if (sessionAbleToRefresh && numberOfRefresh < 3) {
            this._sessionStorageService.store('numberOfRefresh', numberOfRefresh + 1);
            this._ssoService.refreshJwtToken();
          } else {
            this.logOut();
          }
        }
      );
  }

  setHeaderFullName(member: any) {
    const countryCode = this.countryCode.toLowerCase();
    this.memberModel.fullName = this.parseFullName(member.fullName);
    if (member && member.locale && member.locale[countryCode] && member.locale[countryCode].fullname &&
      this._languageService.getDefaultLanguage() === countryCode) {
      this.memberModel.fullName = this.parseFullName(member.locale[countryCode].fullname);
    };
  }

  getMemberTypeCode() {
    return this._authService.getMemberTypeCode();
  }

  goToActivities() {
    switch (this.getMemberTypeCode()) {
      case this.formModel.signUpInvestor.memberTypeCode:
        this._router.navigate(['/admin-investor/activity']);
        break;
      case this.formModel.signUpBorrower.memberTypeCode:
        this._router.navigate(['/admin-borrower/activity']);
        break;
    }
  }

  getFeatureFlag() {
    const { homepageBannerCampaign, partialBannerFlag } = this.featureFlagService.getFeatureFlagKeys();
    this.featureFlagObservable = this.featureFlagService.getFeatureFlagObservable();
    let currentUrl = '';
    const covidCampaignBannerConfiguration = CONFIGURATION.marketingBanner.showCovidCampaignBanner;

    this._router.events.subscribe((url: any) => {
      currentUrl = this._router.url.split('?')[0];
      this.featureFlagObservable.subscribe((flags) => {
        this.showHomepageCampaignBanner = flags[homepageBannerCampaign] && covidCampaignBannerConfiguration && currentUrl === '/';
        this.partialDownTimeBanner.enabled = flags[partialBannerFlag]['enabled'];

        if (this.partialDownTimeBanner.enabled) {
          this.partialDownTimeBanner.message = flags[partialBannerFlag]['message'][this._languageService.getDefaultLanguage()];
        }
        this.headerService.setShowPartialDownTimeBanner(this.partialDownTimeBanner.enabled);
        this.headerService.setShowCampaignBanner(this.showHomepageCampaignBanner);
      });
    }
    );
  }

  closePartialDownTimeBanner() {
    this.partialDownTimeBanner.enabled = false;
    this.headerService.setShowPartialDownTimeBanner(this.partialDownTimeBanner.enabled);
  }

  goToSetting() {
    this.reverseMenuButton();
    this.eventService.sendEvent('settings_click');
    switch (this.getMemberTypeCode()) {
      case this.formModel.signUpInvestor.memberTypeCode:
        this._router.navigate(['/admin-investor/setting']);
        break;
      case this.formModel.signUpBorrower.memberTypeCode:
        this._router.navigate(['/admin-borrower/setting']);
        break;
    }
  }

  redirectForReverification() {
    const link = this.reverificationReasonProperties.find(x => this.reverificationReasonList.includes(x.name));
    if (link) {
      this._router.navigate([link.reverificationLink]);
    }
  }

  goToHelp() {
    const currentLanguage = this._languageService.getDefaultLanguage();
    switch (this.getMemberTypeCode()) {
      case this.formModel.signUpInvestor.memberTypeCode:
        this.navigateToUrl(CONFIGURATION.help.investor[currentLanguage]);
        break;
      case this.formModel.signUpBorrower.memberTypeCode:
        this.navigateToUrl(CONFIGURATION.help.borrower[currentLanguage]);
        break;
      // Help on public page
      default:
        this.navigateToUrl(CONFIGURATION.help.general[currentLanguage]);
    }
  }

  initialize(): void {
    if (this.isTestingEnvironment) {
      this._reviewAppService.changeCountry(this._reviewAppService.getCountry());
      this.countries = this._reviewAppService.getCountries();
      this.environments = this._reviewAppService.getEnvironments();
      this._countryCode = this._reviewAppService.getCountry();
      this._environment = this._reviewAppService.getEnvironment();
      if (!this._reviewAppService.getEnvironment()) {
        this._reviewAppService.changeEnvironment(this._reviewAppService.defaultEnvironment);
      }
    }
    this.headerModel = {
      environmentName: ENVIRONMENT.environment_name,
      isLoggedIn: false,
      isProduction: (ENVIRONMENT.environment_name === 'production'),
      isTestingEnvironment: this.isTestingEnvironment
    };
    this.memberModel = {
      balance: 0,
      currency: CONFIGURATION.currency_symbol,
      currencyFormat: CONFIGURATION.format.decimal,
      localeFormat: CONFIGURATION.format.locale,
      fullName: '',
      userName: ''
    };
    this.modal = {
      activationFailed: false,
      activationSuccess: false,
      borrowerSignUp: false,
      investorSignUp: false,
      inactivityPrompt: false,
      signUp: false
    };
    this.showMenuContainer = false;
    this.showPublicNavigationBar = true;
    this.showReferBox = false;
    this.showServiceBox = false;
  }

  logOut(): void {
    const auth = Boolean(this._localStorageService.retrieve('auth'));
      this._authService.logOut();
      this.eventService.sendEvent('settings_logout_event', {
        'backendStatus': 'Success',
      });
      this.featureFlagService.initializeLdClient();
      this.goToFeedback(null);
      this._ssoService.redirectToLogoutPage();
  }

  navigateToDashboard(): void {
    if (this.redirectUrl) {
      const url = this._authGuardService.getRedirectUrl(this.redirectUrl);
      this.redirectUrl = '';
      this._router.navigate([url]);
    } else {
      switch (this._authService.getMemberTypeCode()) {
        case this.memberTypeCodes.borrower:
          this._router.navigate(['/admin-borrower/overview']);
          break;
        case this.memberTypeCodes.investor:
          this._router.navigate(['/admin-investor/overview']);
          break;
      }
    }
    this.closeAllModals();
  }

  navigateToUrl(url: string): void {
    window.open(url, '_blank');
  }

  onCopyToClipboard(): void {
    this._notificationService.success(this.formModel.referral.copiedMessage);
  }

  onCountrySelectionChange(e): void {
    this._reviewAppService.changeCountry(e.srcElement.selectedOptions[0].value);
    window.location.reload();
  }

  onEnvironmentSelectionChange(e): void {
    this._reviewAppService.changeEnvironment(e.srcElement.selectedOptions[0].value);
    window.location.reload();
  }

  parseFullName(fullName: string): string {
    var parsed = '';
    if (fullName.length > 20) {
      parsed = fullName.replace(',', '').split(' ')[0];
      if (parsed.length > 20) {
        parsed = fullName.substr(0, 20) + '...'
      }
    } else {
      parsed = fullName;
    }

    return parsed;
  }

  reverseMenuButton(): void {
    const dom = window['HYPE']['documents']['dashboard-nav'];
    dom.startTimelineNamed('Main Timeline back', dom.kDirectionReverse);
    this.showMenuContainer = false;
  }

  forwardMenuButton(): void {
    const dom = window['HYPE']['documents']['dashboard-nav'];
    dom.startTimelineNamed('Main Timeline back', dom.kDirectionForward);
    this.showMenuContainer = true;
  }

  toggleMenu() {
    // To make sure only touchStart event is triggered from mobile phone
    if (event['type'] === 'click' && this.utilityService.isMobileBrowser()) {
      return;
    }
    const dom = window['HYPE']?.['documents']?.['dashboard-nav'];
    if (dom && !dom.isPlayingTimelineNamed('Main Timeline back')) {
      // To make sure that the animation completed before we trigger
      // else the animation will stuck if there are multiple triggers
      if (this.showMenuContainer) {
        this.reverseMenuButton();
      } else {
        this.forwardMenuButton();
      }
      this.showReferBox = false;
    }
  }

  share(platform: string): void {
    let referralLink = this.getMemberTypeCode() === this.memberTypeCodes.investor ?
      this.formModel.referral.investorLink + this.formModel.referral.code :
      this.formModel.referral.borrowerLink + this.formModel.referral.code;
    let sharedMessage = '';
    switch (platform) {
      case 'facebook':
        this._referralService.shareOnFacebook(referralLink);
        break;
      case 'google-plus':
        this._referralService.shareOnGooglePlus(referralLink);
        break;
      case 'linked-in':
        this._referralService.shareOnLinkedIn(referralLink, this.formModel.referral.sharedTitle);
        break;
      case 'twitter':
        this._referralService.shareOnTwitter(referralLink);
        break;
    }
  }

  showModal(type: string, optionalData?: any) {
    this.closeAllModals(type);
    this.modal.open = true;
    // Borrrowed from modal.component open method
    this._renderer.addClass(document.body, 'modal-open-fix-for-ios');
    switch (type) {
      case 'ACTIVATION-FAILED':
        this.modal.activationFailed = true;
        break;
      case 'ACTIVATION-SUCCESS':
        this.modal.activationSuccess = true;
        break;
      case 'TWO-FA-LOG-IN':
        // TODO: Refractor this code
        const twoFaConfig = new TwoFaConfig('LOG-IN');
        this.twoFaConfig = Object.assign(twoFaConfig, optionalData);
        this.modal.twoFalogIn = true;
        break;
      case 'INACTIVITY-PROMPT':
        this.modal.inactivityPrompt = true;
    }
  }

  toggleServiceBox() {
    this.showServiceBox = !this.showServiceBox;
  }

  goToStatement() {
    this.reverseMenuButton();
    switch (this.getMemberTypeCode()) {
      case this.formModel.signUpInvestor.memberTypeCode:
        this._router.navigate(['/admin-investor/statement']);
        break;
      case this.formModel.signUpBorrower.memberTypeCode:
        this._router.navigate(['/admin-borrower/statement']);
        break;
    }
  }

  goToFeedback(event: any) {
    this._router.navigate(['/response'], {
      queryParams: {
        feedback: true
      }
    });
  }

  getBorrowerMobilePhoneValidation(validation: boolean) {
    this.formModel.signUpBorrower.mobilePhoneValidation = !validation;
  }


  getInvestorMobilePhoneValidation(validation: boolean) {
    this.formModel.signUpInvestor.mobilePhoneValidation = !validation;
  }

  onTwoFaLogin(): void {
    const pass = this._authService.getTwoFaLoginPass();
    const userName = this._authService.getSignUpCredential().userName;
    const otpChannel = '';
    if (!this.headerModel.isLoggedIn) {
      this._cryptographyService
        .regeneratePublicKey()
        .then(response => {
          this._userService
            .logIn(
              userName,
              this._cryptographyService.encrypt(pass),
              this._cryptographyService.getUuid(),
              otpChannel
            ).subscribe(
              loginResponse => {
                this.onLogIn(loginResponse);
              },
              errorResponse => {
                this._notificationService.error();
              }
            );
        })
        .catch(error => {
          this._notificationService.error();
        });
    } else {
      this.navigateToDashboard();
    }
  }

  onLogIn(onLogInResponse: any) {
    // Normal Login
    const expiryTime = new Date();
    expiryTime.setTime(expiryTime.getTime() + (onLogInResponse.expires_in * 1000));
    this._authService.setRememberMe(true);
    this._authService.setBearerToken(onLogInResponse.access_token);
    this._authService.setExpiryTime(expiryTime);
    this._authService.setRelativeExpiryTime(onLogInResponse.expires_in);
    this._authService.setRefreshToken(onLogInResponse.refresh_token);
    this.getLogInDetails(true, onLogInResponse);
  }

  openCloseHamburgerMenu(): void {
    this.navigation.mobileHamburgerMenuOpen = !this.navigation.mobileHamburgerMenuOpen;
    this.closeSubMenu();
  }

  closeSubMenu(): void {
    this.navigation.activeMobileSubMenu = '';
  }

  closeAllDesktopSubMenus(): void {
    this.navigation.desktopSubMenuOpen = {
      borrow: false,
      about: false,
      login: false,
    }
  }

  toggleDesktopSubMenu(menu: string): void {
    this.navigation.mobileHamburgerMenuOpen = false;
    const subMenuIsOpen = this.navigation.desktopSubMenuOpen[menu];
    this.closeAllDesktopSubMenus();
    // when the sub menu is open, it should toggle to close
    this.navigation.desktopSubMenuOpen[menu] = !subMenuIsOpen;
  }

  navigateToBusinessLogin() {
    if (CONFIGURATION.useBusinessPortalForBorrowers) {
      window.location.href = ENVIRONMENT.businessPortalURL[this.countryFlagCode];
    } else {
      this.toggleDesktopSubMenu('login');
      this._router.navigate(['/log-in/borrower']);
    }
  }
}
